import Modal from './Modal';
import PremiumUpsellCTA from './PremiumUpsellCTA';
import carlImage from 'src/assets/carl.png';

interface PremiumUpsellModalProps {
  open: boolean;
  onClose: () => void;
  /** Optional description of the feature being upsold, shown above the CTA */
  featureDescription?: string;
  ctaText?: string;
  footerText?: string;
}

export default function PremiumUpsellModal({
  open,
  onClose,
  featureDescription,
  ctaText,
  footerText = 'Learn how CompliMind can help to streamline compliance and regulatory management.'
}: PremiumUpsellModalProps) {
  return (
    <Modal open={open} onClose={onClose} className="max-w-lg">
      <div className="flex flex-col items-center py-6 px-4">
        {/* Feature description if provided */}
        {featureDescription && (
          <p className="text-content-default text-base text-center max-w-sm mb-4 font-medium">{featureDescription}</p>
        )}

        {/* Speech bubble CTA */}
        <PremiumUpsellCTA text={ctaText} />

        {/* Carl's photo */}
        <div className="relative mt-2 mb-6">
          <img
            src={carlImage}
            alt="Carl from CompliMind"
            className="w-48 h-48 rounded-full object-cover shadow-xl border-4 border-white"
            style={{
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)'
            }}
          />
          {/* Subtle glow effect */}
          <div
            className="absolute inset-0 rounded-full"
            style={{
              background: 'radial-gradient(circle, transparent 60%, rgba(59, 130, 246, 0.1) 100%)',
              pointerEvents: 'none'
            }}
          />
        </div>

        {/* Additional text */}
        <p className="text-content-subtle text-sm text-center max-w-xs">{footerText}</p>
      </div>
    </Modal>
  );
}
